
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/myCart",
      function () {
        return require("private-next-pages/myCart/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/myCart"])
      });
    }
  